<template>
  <v-container>
    <strong>This page is yet to be created in the new vue project.</strong>
    <div>Current URL: {{ this.$route.path }}</div>
    <hr>
    <strong>Links for testing</strong>
    <div>
      <router-link to="/check">Check Page</router-link>
      <br>
      <router-link to="/check/out">Check Out Page</router-link>
      <br>
      <router-link to="/check/in">Check in Page</router-link>
    </div>

    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'NotYetImplemented'
}
</script>
